import React from "react";
import { Button } from "@mui/material";
import IconLeftArrow from "src/assets/images/icon_left_arrow.svg";
import IconRemove from "src/assets/images/icon_remove.svg";
import { useDispatch } from 'react-redux';
import { toast } from "react-toastify";
import toastMessages from "src/constant/toastMessages.json";
import { unlistDepotPersonnel } from 'src/thunks/depotUsers';
import { GetError } from "src/constant";
import { getAllNofificationForDashboard } from "src/thunks/dashboard";

export const UnlistAccountProjectManager = ({ handleBackButtonClick, setUnlistAccountModel, selectedData }) => {

  /** redux store useDispatch & useSelector ------------------------------ **/
  const dispatch = useDispatch()

  /** handler functions--------------------------------------------------- **/
  const handleUnlistAccountModelClose = () => {
    setUnlistAccountModel(false);
  };

  /** Function that handles the unlisting of project manager accounts. ---------------- **/ 
  const handleUnlistAccountClick = async () => {
    try {
      await dispatch(unlistDepotPersonnel({ ...selectedData, "ProjectUser": true })).unwrap();
      setTimeout(() => {
        dispatch(getAllNofificationForDashboard(1, 20));
      }, 2000);
      setUnlistAccountModel(false);
      toast.success(toastMessages.projectManagerUnlisted)
      handleBackButtonClick();
    }
    catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    }
  }

  return (
    <>
      <div>
        <div className="depot-form-header-style">
          <span className="allocate-mgnr-header-color me-2">UNLIST</span>
          <span className="allocate-mgnr-subheader-color">{selectedData?.projects[0]?.projectClientName || ""}/ {selectedData?.firstName || ""} {selectedData?.lastName || ""}</span>

        </div>
        <div style={{ paddingLeft: 100, paddingRight: 100 }} >
          <div className="d-flex flex-column" style={{ marginTop: 100 }}>
            <span className="depotManagerName-style common-text-for-removeDepotManager">{selectedData?.firstName || ""} {selectedData?.lastName || ""}</span>
            <span className="removeDepotManager-text-removed common-text-for-removeDepotManager mb-3">account will be unlisted.</span>
            <span className="long-text-style-unlist-depot mb-2">This action cannot be undone.</span>
            <span className="long-text-style-unlist-depot mb-2">This does not delete any data. This personnel will still up in old records / search results where relevant </span>
            <span className="long-text-style-unlist-depot">This personnel record can still be accessed through the above.</span>
          </div>

          <div className="d-flex flex-column" style={{ marginTop: 100 }}>
            <span className="mb-3 confirm-msg-for-removeDepotManager">Are you sure you want to proceed?</span>
            <div className="d-flex flex-row">
              <Button variant="outlined" className="btn-bootstrap-submit-style" startIcon={<img src={IconLeftArrow} width={15} height={15} alt="new"></img>} onClick={handleUnlistAccountModelClose} type="submit"
              >
                No, Go Back
              </Button>
              <Button variant="outlined" className="btn-bootstrap-submit-style ms-3" style={{ color: "red", borderColor: "red" }} onClick={handleUnlistAccountClick} startIcon={<img src={IconRemove} width={15} height={15} alt="new"></img>}
              >
                Yes, Unlist Account
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}